import React, {useEffect, useState, useContext} from 'react';
import UpdateFileView from './UpdateFileView';
import {getFilesId} from '../../../../services/MadricService';
import Spinner from '../../../Spinner/Spinner';
import api from '../../../../axios.config';
import swal from 'sweetalert';
import {deleteFile} from '../../../../services/MadricService';
import FileSaver from 'file-saver';
import {useLocation} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {MadricContext} from '../../../../Context/MadricContext';
/**
 *  L'accueil
 * @return {JSX}
 */
function UpdateFile() {
  const [isLoading, setIsLoading] = useState(false);
  const {projectInfo, setProjectInfo, setWhatToShow} = useContext(MadricContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [pdfUrl, setPdfUrl] = useState();
  const [form, setForm] = useState({
    id: null,
    user_id: null,
    note: '',
    name: '',
    date: null,
    permission: false,
    extra1: false,
    extra2: false,
    extra3: false,
  });

  useEffect(() => {
    setIsLoading(true);
    fetchPdfInfo();
  }, []);

  /**
   * Permet de recevoir les info du pdf
   */
  async function fetchPdfInfo() {
    const res = await getFilesId(location.state.file.id, location.state.id);
    const formInfo = {
      id: res.pdfInfo.id,
      user_id: res.pdfInfo.user_id,
      name: res.pdfInfo.name,
      date: res.pdfInfo.date,
      note: res.pdfInfo.note,
      permission: res.pdfInfo.permission,
      extra1: res.pdfInfo.extra1,
      extra2: res.pdfInfo.extra2,
      extra3: res.pdfInfo.extra3,
    };
    setForm(formInfo);

    try {
      if (res.pdf.status === 200) {
        const blob = new Blob([res.pdf.data], {type: 'application/pdf'});
        const url = URL.createObjectURL(blob);

        setPdfUrl(url);
      } else {
        console.error('Error: Unexpected response status -', res.pdf.status);
      }
    } catch (error) {
      console.error('Error:', 'blabla');
    }
    setIsLoading(false);
  }

  /**
   * Download le pdf
   */
  function handleDownload() {
    try {
      FileSaver.saveAs(pdfUrl, form.name);
    } catch {
      console.log('error');
    }
  }

  const handleChangeValue = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeCheckbox = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.checked,
    });
  };

  /**
   * Ferme le modal
   */
  function closeModal() {
    if(location.state.returnTo === 'global')
    {
      navigate('/InfoGlobal');
    }
    else if(location.state.returnTo === 'historique')
    {
      setWhatToShow('7');
      navigate('/chantier/' + location.state.id);
    }
    else
    {
      setWhatToShow('5');
      navigate('/chantier/' + location.state.id);
    }
  }


  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    await api.put('/files/' + form.id, {
      permission: form.permission,
      note: form.note,
      date: form.date,
      extra1: form.extra1,
      extra2: form.extra2,
      extra3: form.extra3,
      name: form.name,
    }).then(() => {
      const updatedList = projectInfo.map((obj) =>
        obj.id === form.id && obj.type === 'file' ? {...obj,
          name: form.name,
          extra1: form.extra1,
          extra2: form.extra2,
          extra3: form.extra3,
          permission: form.permission,
          note: form.note,
          date: form.date,
        } : obj,
      );

      updatedList.sort((a, b) => {
        const dateCompare = b.date.localeCompare(a.date);
        if (dateCompare !== 0) {
          return dateCompare;
        }

        return b.user_id - a.user_id;
      });

      setProjectInfo(updatedList);
    }).finally(() => {
      location.state.returnTo === 'historique' ? setWhatToShow('7') : setWhatToShow('5');

      if(location.state.returnTo === 'global')
      {
        navigate('/InfoGlobal');
      }
      else if(location.state.returnTo === 'historique')
      {
        setWhatToShow('7');
        navigate('/chantier/' + location.state.id);
      }
      else
      {
        setWhatToShow('5');
        navigate('/chantier/' + location.state.id);
      }
    });
  };

  /**
   * Supprime le modal
   */
  function handleDelete() {
    swal({
      title: 'Êtes-vous sûre de vouloir supprimer ce fichier',
      text: 'Une fois supprimer vous n\'y aurai plus accès',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            setIsLoading(true);
            const filtered = projectInfo.map((obj) => {
              return obj.id === form.id && obj.type === 'file' ? null : obj;
            }).filter((item) => item !== null);

            setProjectInfo(filtered);

            await deleteFile(location.state.file.id, location.state.id);
            setIsLoading(false);

            swal('Supprimé!', {
              icon: 'success',
            });

            if(location.state.returnTo === 'global')
            {
              navigate('/InfoGlobal');
            }
            else if(location.state.returnTo === 'historique')
            {
              setWhatToShow('7');
              navigate('/chantier/' + location.state.id);
            }
            else
            {
              setWhatToShow('5');
              navigate('/chantier/' + location.state.id);
            }
          } else {
            swal('Annulé!');
          }
        });
  }


  return (
    <React.Fragment>
      {isLoading && <Spinner />}

      <UpdateFileView
        form={form}
        pdfUrl={pdfUrl}
        handleChangeValue={handleChangeValue}
        handleChangeCheckbox={handleChangeCheckbox}
        handleDownload={handleDownload}
        handleSubmit={handleSubmit}
        closeModal={closeModal}
        handleDelete={handleDelete} />
    </React.Fragment>
  );
}

export default UpdateFile;
